module.exports = __webpack_public_path__ + "img/room-1.70bcda4b.jpg";